import * as React from 'react';
import { ReactElement } from 'react';
import {
    ListItemButton,
    ListItemButtonProps,
    ListItemText,
} from '@mui/material';

import { useSearchHistoryContext } from './SearchHistoryContext';
/**
 * A component responsible for displaying a single search history item.
 *
 * @param props {SearchHistoryItemProps}
 * @param props.item {string} The history item
 * @param props.onSelect {Function} The function to call when the item is selected.
 */
export const SearchHistoryItem = (
    props: SearchHistoryItemProps
): ReactElement => {
    const { onSelect, item } = useSearchHistoryContext();

    if (!item) {
        return null;
    }

    const handleClick = (): void => {
        onSelect(item);
    };

    const handleKeyEnter = (event): void => {
        if (event.ctrlKey && event.keyCode == '13') {
            onSelect(item);
        }
    };

    return (
        <ListItemButton
            component="i"
            onClick={handleClick}
            onKeyPress={handleKeyEnter}
            {...props}
        >
            <ListItemText primary={item} />
        </ListItemButton>
    );
};

type SearchHistoryItemProps = Omit<ListItemButtonProps, 'onSelect'>;
